<template>
  <div style="width:100%; height:100%; padding: 5px;">
 
    <!-- <dv-decoration-2 class="decoration-1" :reverse="true" style="width:5px;margin-right:30px" :dur="durtime" /> -->
    <div v-if="shap == 1" style="width:100%; height:100%;">
      <div class="c-name" style="font-size:30px;top:20px">
        {{chartname}}
      </div>
      <dv-water-level-pond :config="config" style="margin-top:30px;width:370px;height:370px" />
    </div>
    <div v-if="shap == 2" class="small-boll">
      <div class="chartname">
          <div class="">
            {{chartname}}
          </div>
          <div class="">
            {{chartname_E}}
          </div>
      </div>
      <div class="" >
        <dv-water-level-pond :config="config"  style="width:155px;height:155px;margin:auto"/>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: 'OEECharts',
  components: {

  },
  props: {
    'oee':Number,
    'chartname':String,
    'chartname_E':String,
    'shap':Number
  },
  data () {
    return {
      durtime: 30,
      namesize: 'font-size:' + this.size,
      config:{
        data: [this.oee * 100],
        shape: 'round'
      },
      config1: {
        data: [
          {
            name: '收费站',
            value: 356
          },
          {
            name: '监控中心',
            value: 215
          },
          {
            name: '道路外场',
            value: 90
          },
          {
            name: '其他',
            value: 317
          }
        ],
        color: ['#00baff', '#3de7c9', '#fff', '#ffc530', '#469f4b'],
        radius: '65%',
        activeRadius: '70%'
      },

      config2: {
        data: [
          {
            name: '收费站',
            value: 615
          },
          {
            name: '监控中心',
            value: 322
          },
          {
            name: '道路外场',
            value: 198
          },
          {
            name: '其他',
            value: 80
          }
        ],
        color: ['#00baff', '#3de7c9', '#fff', '#ffc530', '#469f4b'],
        radius: '65%',
        activeRadius: '70%'
      },

      config3: {
        data: [
          {
            name: '收费站',
            value: 452
          },
          {
            name: '监控中心',
            value: 512
          },
          {
            name: '道路外场',
            value: 333
          },
          {
            name: '其他',
            value: 255
          }
        ],
        color: ['#00baff', '#3de7c9', '#fff', '#ffc530', '#469f4b'],
        radius: '65%',
        activeRadius: '70%'
      },

      config4: {
        data: [
          {
            name: '收费站',
            value: 156
          },
          {
            name: '监控中心',
            value: 415
          },
          {
            name: '道路外场',
            value: 90
          },
          {
            name: '其他',
            value: 210
          }
        ],
        color: ['#00baff', '#3de7c9', '#fff', '#ffc530', '#469f4b'],
        radius: '65%',
        activeRadius: '70%'
      },

      labelConfig: {
        data: ['收费站', '监控中心', '道路外场', '其他']
      }
      ,
      option1: {
          series: [
            {
              type: 'gauge',
              startAngle: -Math.PI / 2,
              endAngle: Math.PI * 1.5,
              arcLineWidth: 25,
              data: [
                { name: 'itemA', value: 65, gradient: ['#03c2fd', '#1ed3e5', '#2fded6'] }
              ],
              axisLabel: {
                show: false
              },
              axisTick: {
                show: false
              },
              pointer: {
                show: false
              },
              dataItemStyle: {
                lineCap: 'round'
              },
              details: {
                show: true,
                formatter: '{value}%',
                style: {
                  fill: '#1ed3e5',
                  fontSize: 35
                }
              }
            }
          ]
        },
        option2: {
          series: [
            {
              type: 'gauge',
              startAngle: -Math.PI / 2,
              endAngle: Math.PI * 1.5,
              arcLineWidth: 25,
              data: [
                { name: 'itemA', value: 65, gradient: ['#03c2fd', '#1ed3e5', '#2fded6'] }
              ],
              axisLabel: {
                show: false
              },
              axisTick: {
                show: false
              },
              pointer: {
                show: false
              },
              dataItemStyle: {
                lineCap: 'round'
              },
              details: {
                show: true,
                formatter: '{value}%',
                style: {
                  fill: '#1ed3e5',
                  fontSize: 35
                }
              }
            }
          ]
        },
        option3: {
          series: [
            {
              type: 'gauge',
              startAngle: -Math.PI / 2,
              endAngle: Math.PI * 1.5,
              arcLineWidth: 25,
              data: [
                { name: 'itemA', value: 65, gradient: ['#03c2fd', '#1ed3e5', '#2fded6'] }
              ],
              axisLabel: {
                show: false
              },
              axisTick: {
                show: false
              },
              pointer: {
                show: false
              },
              dataItemStyle: {
                lineCap: 'round'
              },
              details: {
                show: true,
                formatter: '{value}%',
                style: {
                  fill: '#1ed3e5',
                  fontSize: 35
                }
              }
            }
          ]
        }
    }
  },
  mounted(){
    this.$data.durtime = this.$cookies.get('refreshTime')
  },
  watch: {
     'oee': function(newVal){
         this.$data.config.data[0] = Number((this.oee*100).toFixed(2))
         this.$data.config = {...this.$data.config}     
      },
  }


}
</script>

<style lang="less">
.c-name{
  width:100%;
  height: 100%;
  z-index: 999;
  position: absolute;
}
.small-boll{
  width:100%;
  height: 100%;

}
.chartname{
  width:100%;
  font-size: 16px;
  text-align: center;
  margin-bottom: 2px;
}
.smallchart{
  width: 100%;
  height: 100%;
  margin: 2px;
}
.bottom-charts {
  width: 100%;
  height: 100%;
  //display: flex;
  //position: relative;

  .bc-chart-item {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
  .dv-active-ring-chart {
    height: calc(~"100% - 80px");
  }

  .label-tag {
    height: 30px;
  }

  .active-ring-name {
    font-size: 18px !important;
  }

  .decoration-1, .decoration-2, .decoration-3 {
    display: absolute;
    left: 0%;
  }
}
</style>
